import React, { useMemo } from "react";
import * as Scrivito from "scrivito";
import { UncontrolledTooltip } from "reactstrap";
import cx from "classnames";

import { useTranslate } from "hooks";
import { Button } from "components";
import { DuplicateButton } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardQuestionnaire/WizardQuestionnaireTitleIcons/DuplicateButton";
import {
  useIsFetching,
  useQuestionnaireLists,
  useWizardActions,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import s from "../WizardQuestionnaire.module.scss";

export const WizardQuestionnaireTitleIcons = Scrivito.connect(
  ({ isFieldsConstraintViolated }) => {
    const translate = useTranslate();
    const { deleteWizardStepQuestionnaire } = useWizardActions();

    const questionnaireLists = useQuestionnaireLists();
    const isSomethingFetching = useIsFetching();

    const disabled = useMemo(
      () => isSomethingFetching || questionnaireLists.length <= 1,
      [isSomethingFetching, questionnaireLists],
    );

    const handleDeleteQuestionnaire = () => {
      deleteWizardStepQuestionnaire();
    };

    return (
      <div className="d-flex align-items-center">
        {/* TODO: needs some discussion with AB team yet */}
        <DuplicateButton
          {...{
            isFieldsConstraintViolated,
            currentZoneFetching: false,
          }}
        />
        {/* TODO: can be implemented after handling switching between zones */}
        <Button
          /* TODO: forthcoming feature (hidden acc US-19953) removed 'border-end' from className */
          data-testid="WizardQuestionnaireTitleIcons_delete-btn"
          className={cx(
            "px-2 py-0 lh-0 shadow-none border-0 ",
            s.wizardQuestionnaireHeaderButton,
            {
              invisible: questionnaireLists.length <= 1,
            },
          )}
          color="transparent"
          icon="trash-can-light"
          disabled={disabled}
          iconClassName="icon-20"
          iconPrefix="trox"
          onClick={handleDeleteQuestionnaire}
          id="wizard_top_delete_icon"
        />
        <UncontrolledTooltip target="wizard_top_delete_icon" placement="top">
          {translate("DELETE")}
        </UncontrolledTooltip>
        {/* TODO: forthcoming feature (hidden acc US-19953) */}
        {/* <Dropdown
          btnChildren={
            <Icon
              prefix="trox"
              iconName="ellipsis-vertical-regular"
              className="icon-20"
            />
          }
          btnClassName={s.wizardQuestionnaireHeaderButton}
          btnId="wizard_top_more_actions_icon"
          options={[
            {
              id: "copy_properties",
              title: translate("COPY_PROPERTIES"),
            },
            {
              id: "paste_properties",
              title: translate("PASTE_PROPERTIES"),
            },
          ]}
        /> */}
        {/* <UncontrolledTooltip
        target="wizard_top_more_actions_icon"
        placement="top"
      >
        {translate("MORE_ACTIONS")}
      </UncontrolledTooltip> */}
      </div>
    );
  },
);
